import script from "./AiHelpAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./AiHelpAssistant.vue?vue&type=script&setup=true&lang=js"

import "./AiHelpAssistant.vue?vue&type=style&index=0&id=206e7da3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206e7da3"]])

export default __exports__